<rid-demo-page [title]="'Klankbord Plus'" previousRoute="/mechanics">
  <rid-button class="w-full" content="Klankbord plus | instructiemodus" variant="PRIMARY" routerLink="freeform" />
  <rid-button class="w-full" content="Klankbord plus | klankvoeten" variant="PRIMARY" routerLink="klankvoeten" />
  <rid-button class="w-full" content="Klankbord plus | pas de regel toe" variant="PRIMARY" routerLink="apply-rule" />
  <rid-button class="w-full" content="Klankbord plus | kies de regel" variant="PRIMARY" routerLink="choose-rule" />
  <rid-button class="w-full" content="Klankbord plus | regelrecht" variant="PRIMARY" routerLink="direct-rule-application" />
</rid-demo-page>
